var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgIconLotus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.5 8.333c0 3.222 2.5 5.834 2.5 5.834s2.5-2.612 2.5-5.834C12.5 5.112 10 2.5 10 2.5S7.5 5.112 7.5 8.333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.276 6.666c-1.847-.795-3.609-.833-3.609-.833s.08 3.651 2.38 5.952C6.35 14.087 10 14.166 10 14.166s3.652-.08 5.953-2.38c2.3-2.302 2.38-5.953 2.38-5.953s-1.761.038-3.608.833M10.018 14.167c-.139 1.111.533 3.333 2.91 3.333 1.663 0 2.495-1.666 5.406 0-.334-1.666-1-2.733-1.973-3.333m-6.378 0c.139 1.111-.533 3.333-2.91 3.333-1.664 0-2.495-1.666-5.406 0 .333-1.666 1-2.733 1.973-3.333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLotus);
export default __webpack_public_path__ + "static/media/icon-lotus.b1f25bfd6b8bd35e1836f30d1abf3706.svg";
export { ForwardRef as ReactComponent };